import React, { MutableRefObject, ReactElement, useLayoutEffect, useRef, useState } from 'react';
import { Button } from '@capcenter/shared';
import classNames from 'classnames';

import './ExpansionComponent.scss';

interface ExpansionComponentProps {
  content: ReactElement,
  isOpen: boolean,
  className?: string,
  id: string,
  openLabel: string,
  closedLabel: string,
  openIcon: string,
  closedIcon: string,
  buttonClass?: string,
  onButtonClick: () => void,
  bpSM: boolean
}


const ExpansionComponent = ({content, isOpen, className, id, openLabel, closedLabel, openIcon, closedIcon, buttonClass, onButtonClick, bpSM} : ExpansionComponentProps) => {
	const ref = useRef() as MutableRefObject<HTMLDivElement>;
	const [contentHeight, setContentHeight] = useState<number>(0);
	const [closedHeight, setClosedHeight] = useState<number>(0);

	useLayoutEffect(() => { 
		const refHeight = ref.current.getBoundingClientRect().height;
		setContentHeight(refHeight);
		setClosedHeight(refHeight < 120 ? refHeight : (refHeight * .4) > 250 ? 250 : (refHeight * .4));

    
		const detailsWindow = document.getElementById('propertydetails');
		const detailsTop = document.getElementById('propertyDetailsFull')!.getBoundingClientRect().top;
		if (detailsTop < 0) {
			detailsWindow?.scrollBy(0, detailsTop - 100);
		}

	}, [content, ref]);


	const expansionStyle = {
		height: isOpen ? contentHeight : closedHeight,
		overflow: 'hidden',
		minHeight: contentHeight < 120 ? 100 : 120
	};

	return (
		<div className={classNames(className)}>
			<div className="expansion-content__content-wrapper">
				<div id={id} className="expansion-content" aria-expanded={isOpen} style={expansionStyle}>
					{contentHeight > 120 && (
						<div className={classNames(!isOpen && 'expansion-content__fade-overlay--active', 'expansion-content__fade-overlay')} />
					)}
					<div ref={ref}>
						{content}
					</div>
				</div>
				{contentHeight > 120 && (
					<div className="w-100 text-center pt-1">
						<Button bold fullWidth resetText label={isOpen ? openLabel : closedLabel} color="secondary" variant="flat" iconSuffix={isOpen ? openIcon : closedIcon} className={classNames(buttonClass, !bpSM ? 'w-75 mx-auto' : 'w-100', 'col-12 col-sm-8 col-lg-3')} onClick={() => onButtonClick()} />
					</div>
				)}
			</div>
		</div>
	);
};

export default ExpansionComponent;